const AmazonQuery = (searchQuery, commandList) => {
    let queryParts = [encodeURIComponent(searchQuery)];
    let ampersandCommands = ''; // &で始まるコマンドを格納する変数

    // Amazon用のコマンド処理
    commandList.forEach(({ command, value }) => {
        // 値があるかつ&で始まるコマンドを特別扱いする
        if (command.startsWith('&')) {

            switch (command) {
                case '&high-price=':
                    ampersandCommands +=`${command}${value}`;
                break;
                case '&low-price=':
                    ampersandCommands +=`${command}${value}`;
                break;
                case '&pct-off=':
                    ampersandCommands +=`${command}${value}-99`;
                break;
            default:
                ampersandCommands += `${value}`;
            }

        } else if (value) { // それ以外のコマンドはqueryPartsに追加する
            switch (command) {
                case 'keyword':
                    queryParts.push(`${encodeURIComponent(value)}`);
                    break;
                case '|':
                    queryParts.push(`${encodeURIComponent(value)}`);
                    break;
                default:
                    // 上記以外で&で始まらないコマンドは通常のパラメータとして扱う
                    queryParts.push(`${command}${encodeURIComponent(value)}`);
            }
        }
    });

    // 複数の検索項目がある場合に限り、'+'で連結し、最後に&で始まるコマンドを追加
    const fullQuery = queryParts.join('+') + ampersandCommands;
    console.log(fullQuery);
    return 'https://www.amazon.co.jp/s?k=' + fullQuery;
};

export default AmazonQuery;
